import { useQuery } from '@tanstack/react-query';

export const useAlgoPriceQuery = () => {
  return useQuery({
    queryKey: ['algoPrice'],
    queryFn: async () => {
      const response = await fetch('/api/algo/details');
      return await response.json();
    },
  });
};
